import { Typography } from "@circle-react-uikit/Typography";
import { classNames } from "@circle-react/helpers/twMergeWithCN";

import { t } from "@/i18n-js/instance";

import { usePlans } from "../../RegularPlan/PlansContext";
import { getCompareTableGridColsClass } from "../../utils/compareTableGridCols";

const tierTranslations: Record<string, () => string> = {
  basic: () =>
    t("pricing_plans.plan_settings.plan_selection.features.tiers.basic"),
  professional: () =>
    t("pricing_plans.plan_settings.plan_selection.features.tiers.professional"),
  business: () =>
    t("pricing_plans.plan_settings.plan_selection.features.tiers.business"),
  enterprise: () =>
    t("pricing_plans.plan_settings.plan_selection.features.tiers.enterprise"),
  plus: () =>
    t("pricing_plans.plan_settings.plan_selection.features.tiers.plus"),
};

export const TierHeaders = () => {
  const { compareTablePlanFeatures } = usePlans();
  if (!compareTablePlanFeatures) return null;

  const tiers = Object.keys(compareTablePlanFeatures);
  return (
    <div
      className={classNames(
        "mb-4 grid",
        getCompareTableGridColsClass(tiers.length + 1),
      )}
    >
      <Typography.LabelMd weight="semibold">
        {t("pricing_plans.plan_settings.plan_selection.features.usage")}
      </Typography.LabelMd>
      {tiers.map(tier => (
        <Typography.LabelMd key={tier} weight="semibold">
          {tierTranslations[tier]?.() ?? tier}
        </Typography.LabelMd>
      ))}
    </div>
  );
};
